import * as React from "react";
import { Row, Col, Empty, Button } from "antd";
import CargoChargesResultModel from "components/CargoCharges/CargoChargesResults/CargoChargesResultsModel";
import { CargoChargeItem } from "components/CargoCharges/CargoChargesResults";
import { StyleCargoChargesResultContainer } from "components/CargoCharges/CargoCharges.Style";
import CargoChargesForm from "components/CargoCharges/CargoChargesForm";
import * as QueryString from "query-string";
import { RouteComponentProps, withRouter } from "react-router-dom";
import NotificationUtility from "Core/NotificationUtility";

export interface Props extends RouteComponentProps {
    children?: React.ReactNode
}
export interface State {
    bolNo?: string
}

class CustomerBolChargeBase extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    componentDidMount() {
        if (QueryString.parse(this.props.location.search) !== undefined) {
            const { bolNo } = QueryString.parse(this.props.location.search);
            if (bolNo != null || bolNo != undefined) {
                this.setState({ bolNo })
            }
            else {
                //NotificationUtility.info("No Bill of Laden with that number found.", "", 30, true);
                //TODO: CHANGE TO CLICK N GO PAGE WHEN IT IS OFFICIALLY CREATED
                // this.props.history.push("/home");
            }
        }
    }

    goBack = (e: React.FormEvent) => {
        e.preventDefault();
        this.props.history.push("/customer-bol");
    }



    render() {
        return (

            <Row>
                <Col>
                    <Row>
                        <Col span={2}>
                            <Button icon="arrow-left" size="small" onClick={this.goBack} type="primary">
                                Back
                    </Button>
                        </Col>

                    </Row>
                    <Row>
                        <CargoChargesForm hideCheckoutButton={true} checkoutButtonRoute="/cart" />
                    </Row>
                </Col>
            </Row>
        )
    }
}

const CustomerBolCharge = withRouter(CustomerBolChargeBase);

export default CustomerBolCharge;